// export const BASEURL = 'http://192.168.1.46:4000' 
// export const BASEURL = 'http://147.79.67.218:4000'
export const BASEURL = 'https://sculptskincare.cloud/api'

// export const BASEURL = 'http://localhost:4000'

export const BARCODE_URL = 'http://localhost:3000'
    
